import {StyleSheet} from 'react-native';
import {textStyles} from '../../styles/Colors';
import {colorPalette} from '../../theme';
import { font } from '../../theme/Font';

export default StyleSheet.create({
  container: {
    backgroundColor: colorPalette.oldPrimary,
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 18,
    paddingTop: 7.5,
    paddingBottom: 10,
    flexDirection: 'row',
  },
  absolute: {
    position: 'absolute',
  },
  title: {
    fontFamily: font[500],
    fontSize: 18,
    color: colorPalette.whiteGrey0,
  },
  loading: {
    height: 24,
    width: 24,
    position: 'absolute',
  },
  icon: {
    marginRight: 8,
  },
});
